// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NFKn","content":"styles_content__KKReS"};